import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.503 2.5a.5.5 0 0 1 1 0v11.793l2.275-2.275a.492.492 0 0 1 .7.007.5.5 0 0 1 .007.7L12.35 15.86a.483.483 0 0 1-.345.143.501.501 0 0 1-.349-.143l-3.134-3.134a.492.492 0 0 1 .006-.7.5.5 0 0 1 .7-.008l2.275 2.275V2.5zM10 6.5a.5.5 0 0 1-.5.5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-3.5a.5.5 0 0 1 0-1H18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.5a.5.5 0 0 1 .5.5z"
});

var SvgDownload = function SvgDownload(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgDownload;